import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsis } from "@fortawesome/pro-regular-svg-icons";
import { faFolder } from "@fortawesome/pro-solid-svg-icons";
import { IDropdownItem } from "../dropdown/dropdownUtils";
import Dropdown from "../dropdown/Dropdown";
import Button from "../button/Button";

interface IProps {
    /** Ancestor segments in original format (may include trailing "/"), e.g. ["", "abc/", "abc/"] */
    segments: string[];
    size: "small" | "medium" | "large";
    /** Returns the FULL path (no trailing slash), e.g. "/", "/abc", "/abc/abc" */
    onChange: (fullPath: string) => void;
}

export default function FolderingDropdown(props: IProps) {
    const { t } = useTranslation();

    const stripSlashes = (s: string) => s.replace(/^\/+|\/+$/g, ""); // remove leading/trailing slashes
    const titleFor = (seg: string, idx: number) =>
        idx === 0 ? t("Shared.index") : stripSlashes(seg) || t("Shared.index");

    // Build items with cumulative, unambiguous fullPath in `id`
    const items: IDropdownItem[] = props.segments.map((seg, idx) => {
        const fullPath =
            idx === 0
                ? "/"
                : "/" +
                  props.segments
                      .slice(1, idx + 1) // take up to the clicked ancestor
                      .map(stripSlashes) // normalize "abc/" -> "abc"
                      .filter(Boolean) // guard against empty parts
                      .join("/"); // "/abc/abc"

        return {
            id: fullPath, // what onChange should return
            title: titleFor(seg, idx), // "Index", "abc", "abc"
            icon: <FontAwesomeIcon className="yellow" icon={faFolder} />,
        };
    });

    return (
        <Dropdown
            items={items}
            onChange={(item) => props.onChange(item.id)} // returns full path
            trigger={
                <Button variant="secondary" iconOnly size={props.size}>
                    <div className="userful-dropdown-icon-wrapper">
                        <FontAwesomeIcon icon={faEllipsis} />
                    </div>
                </Button>
            }
        />
    );
}
